import { useUser } from "../hooks/useUser";
import { BottomNav } from "../components/BottomNav";
import { HeaderAvatars } from "../components/HeaderAvatars";

export function InsightsPage() {
  const { data: user } = useUser();
  const userInitial = (user?.name || "?")[0]?.toUpperCase();
  const partnerInitial = (user?.partner_name || "?")[0]?.toUpperCase();
  const partnerJoined = !!user?.conversations?.find(c => c.type === "group");

  const weeklyItems = [
    { emoji: "📊", title: "Your Numbers", subtitle: "Affect ratio & repair rate" },
    { emoji: "📣", title: "Communication Score", subtitle: "How you're engaging together" },
    { emoji: "⭐", title: "Wins Last Week", subtitle: "Celebrate what's working" },
    { emoji: "☑️", title: "Try This Week", subtitle: "Keep growing together" },
  ];

  return (
    <div className="min-h-screen-safe bg-[#F8F8F6] flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <div className="max-w-md mx-auto w-full px-4 pb-32">
          {/* Header */}
          <header className="flex items-center justify-between py-4 pt-8">
            {partnerJoined ? (
              <HeaderAvatars
                userInitial={userInitial}
                partnerInitial={partnerInitial}
                partnerJoined
                onInviteClick={() => undefined}
              />
            ) : (
              <div className="w-9 h-9" />
            )}
            <span className="font-serif text-lg text-[#1a1a1a]">Insights</span>
            <div className="w-9 h-9" />
          </header>

          {partnerJoined ? (
            <div className="flex-1 flex items-center justify-center py-24">
              <div className="px-8 py-12 text-center max-w-sm mx-auto">
                <div className="w-20 h-20 rounded-full bg-[#e4e2dc] flex items-center justify-center mx-auto mb-6">
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#8a9a8a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                  </svg>
                </div>
                <h2 className="font-serif font-medium text-xl text-[#1a1a1a] mb-4">Coming soon</h2>
                <p className="text-sm text-[#8a8a8a] leading-relaxed">
                  Your weekly report cards will live here soon. For now, keep chatting and we'll text you your insights on Fridays.
                </p>
              </div>
            </div>
          ) : (
            <div className="space-y-8 py-6">
              {/* Hero Card */}
              <div className="bg-[#2d4739] rounded-3xl p-6 text-white text-center shadow-[0px_1px_10px_0px_rgba(0,0,0,0.1)]">
                <div className="text-4xl mb-6">📊</div>
                <h2 className="font-serif font-medium text-2xl mb-2">
                  Unlock Your Weekly Report
                </h2>
                <p className="text-sm opacity-90 mb-6 leading-relaxed">
                  Personalized insights arrive every Friday once your shared thread is active.
                </p>
                <div className="inline-flex items-center bg-white/15 rounded-full px-4 py-2 text-xs font-medium">
                  📅 Delivered Fridays
                </div>
              </div>

              {/* What you'll see */}
              <div>
                <p className="text-xs font-bold text-[#6b7c6b] uppercase tracking-wide mb-4">
                  What you'll see each week
                </p>
                <div className="space-y-2">
                  {weeklyItems.map((item) => (
                    <div
                      key={item.title}
                      className="bg-white border border-[#e0ded8] rounded-xl p-4 flex items-center gap-3.5 shadow-[0px_1px_10px_0px_rgba(0,0,0,0.1)]"
                    >
                      <div className="w-9 h-9 rounded-lg bg-[#f5f3ef] flex items-center justify-center text-sm shrink-0">
                        {item.emoji}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="font-bold text-[#1a2e1a]">{item.title}</p>
                        <p className="text-sm text-[#5a5a5a]">{item.subtitle}</p>
                      </div>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#c0c0c0" strokeWidth="1.5" className="shrink-0">
                        <rect x="5" y="9" width="10" height="8" rx="2" />
                        <path d="M7 9V7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7V9" />
                      </svg>
                    </div>
                  ))}
                </div>
              </div>

              {/* Sample insight */}
              <div className="border border-dashed border-[#d0cdc6] rounded-2xl p-5" style={{ background: "linear-gradient(144deg, #f8f7f4 0%, #f0eee8 100%)" }}>
                <p className="text-xs font-bold text-[#8a9a8a] uppercase tracking-wide mb-2.5">
                  💬 Sample insight
                </p>
                <p className="text-sm italic text-[#4a5a4a] leading-relaxed">
                  "You both made space to celebrate each other's successes and{" "}
                  <span className="blur-[2px]">openly express gratitude</span>..."
                </p>
              </div>

            </div>
          )}
        </div>
      </div>

      {/* Bottom nav */}
      <div className="fixed bottom-0 left-0 right-0 z-40">
        <div className="max-w-md mx-auto w-full">
          <BottomNav />
        </div>
      </div>
    </div>
  );
}
